import React, { useState, useEffect } from 'react';
import { GetRequest } from 'components/common/index.js';

const DrawingOptions = ({ theme, id, setId, drawing, unitOption = 'both', onUnitChange }) => {
  // Set initial unit based on unitOption: if forced to 'mm' or 'in', use that; otherwise default to 'mm'
  const initialUnit = unitOption === 'in' ? 'in' : 'mm';
  const [unit, setUnit] = useState(initialUnit);
  const [options, setOptions] = useState([]);

  const fetchOptions = () => {
    GetRequest({
      url: `/widget-drawing-options/0/${window.locale}/${id}/${unit}`,
      callback: (data) => {
        setOptions(() => data.values);
      }
    });
  };

  const getOption = (option) => {
    if (option.input_type === 'length' && option.possible_values.length === 0) {
      const OptionLengthWithUnit = theme.OptionLengthWithUnit;
      return (
        <OptionLengthWithUnit
          key={option.name}
          id={id}
          drawing={drawing}
          option={option}
          unit={unit}
        />
      );
    }

    if (option.input_type === 'boolean') {
      const OptionBoolean = theme.OptionBoolean;
      return (
        <OptionBoolean
          key={option.name}
          id={id}
          drawing={drawing}
          option={option}
          unit={unit}
        />
      );
    }

    if (option.input_type === 'integer' && option.possible_values.length === 0) {
      const OptionIntegerWithRange = theme.OptionIntegerWithRange;
      return (
        <OptionIntegerWithRange
          key={option.name}
          id={id}
          drawing={drawing}
          option={option}
          unit={unit}
        />
      );
    }

    if (option.input_type === 'select') {
      const OptionSelect = theme.OptionSelect;
      return (
        <OptionSelect
          key={option.name}
          id={id}
          drawing={drawing}
          option={option}
          unit={unit}
        />
      );
    }

    // Throw error for unsupported option types so we know to add support
    throw new Error(`[DrawingOptions] Unsupported option type: ${option.input_type} (option: ${option.name})`);
  };

  useEffect(fetchOptions, [id, unit]);
  // The visitor's unit, for the form's other lengths (the hot stamping area).
  useEffect(() => {
    if (onUnitChange) { onUnitChange(unit); }
  }, [unit]);

  const SelectQuantity = theme.SelectQuantity;
  const SelectUnit = theme.SelectUnit;

  // Only show unit selector if unitOption is 'both'
  const showUnitSelector = unitOption === 'both';

  const quantityField = <SelectQuantity id={id} drawing={drawing} unit={unit} />;
  const unitField = showUnitSelector ? (
    <SelectUnit id={id} drawing={drawing} unit={unit} setUnit={setUnit} />
  ) : (
    <input type="hidden" name="unit" value={unit} />
  );
  const optionFields = options.map(getOption);

  // A theme that groups the form (the island themes) places the fields itself, quantity after the dimensions.
  const DrawingOptionsLayout = theme.DrawingOptionsLayout;
  if (DrawingOptionsLayout) {
    return <DrawingOptionsLayout quantity={quantityField} unit={unitField} options={optionFields} />;
  }

  return (
    <>
      {quantityField}
      {unitField}
      {optionFields}
    </>
  );
}

export default DrawingOptions;
